import { Injectable } from '@angular/core';
import { GridService } from '../../shared/grid/grid.service';
import { FormatService } from '../../shared/format/format.service';
import { UserSettingsService } from '../../user/core/user-settings.service';

@Injectable()
export class SummaryPageGridService extends GridService {

  constructor(public userSettings: UserSettingsService, public formatService: FormatService) {
    super('app.quoting.quoting-summary-grid', userSettings);
  }

  defaultColumns = [
    {
      caption: 'ID',
      dataType: 'text',
      dataField: 'quote_service_id',
      width: 150
    },
    {
      caption: 'Quote Type',
      alignment: 'left',
      dataType: 'text',
      dataField: 'quoting_type.value',
      width: 120
    },
    {
      caption: 'Vendor',
      alignment: 'left',
      dataField: 'selected_offer.vendor.name',
      cellTemplate: 'emptyCellTemplate'
    },
    {
      dataField: 'address.search_address',
      caption: 'Address',
      alignment: 'left',
      cellTemplate: "addresstemplate",
      width: 200
    },
    {
      caption: 'Service Type',
      alignment: 'left',
      dataField: 'quote_service_type.value',
      cellTemplate: 'emptyCellTemplate'
    },

    {
      caption: 'Svc BW',
      alignment: 'left',
      dataField: 'circuit_bandwidth.value',
      cellTemplate: 'emptyCellTemplate'
    },

    {
      caption: 'Port BW',
      alignment: 'left',
      dataField: 'port_bandwidth.value',
      cellTemplate: 'emptyCellTemplate'
    },

    {
      caption: 'Create Date',
      dataType: 'date',
      format: this.formatService.date,
      width: 100,
      dataField: 'create_date',
      cellTemplate: 'emptyCellTemplate',
    },

    {
      caption: 'Close Date',
      dataType: 'date',
      format: this.formatService.date,
      width: 100,
      dataField: 'complete_date',
      cellTemplate: 'emptyCellTemplate',
    },

    {
      caption: 'Medium',
      alignment: 'left',
      width: 100,
      dataField: 'selected_offer.quote_service_medium.value',
      cellTemplate: 'emptyCellTemplate',
      visible: false,
    },
    {
      caption: 'Interval',
      width: 100,
      dataField: 'selected_offer.interval',
      cellTemplate: 'emptyCellTemplate',
      visible: false,
    },
    {
      caption: 'Sent Date',
      dataType: 'date',
      format: this.formatService.date,
      width: 100,
      dataField: 'selected_offer.quote_date',
      cellTemplate: 'emptyCellTemplate',
      visible: false,
    },
    {
      caption: 'Status',
      width: 100,
      dataField: 'quote_service_status.value',
    },
    {
      caption: 'Term',
      alignment: 'left',
      width: 130,
      dataField: 'selected_term',
      cellTemplate: 'emptyCellTemplate'
    },
  ];

  /*
  this function covers special case and it is used only for CSV not for grid
  */
  getServiceCSVColumns() {
    return [
      {
        label: 'Quote Service ID',
        type: 'text',
        value: 'quote_service_id'
      },
      {
        label: 'Quote Service Type',
        type: 'text',
        value: 'quote_service_type.value'
      },
      {
        label: 'Service Status',
        type: 'text',
        value: 'service_status'
      },
      {
        label: 'Details',
        type: 'text',
        value: 'service_details'
      },
      {
        label: 'Selected Term',
        type: 'text',
        value: 'selected_term'
      },
      {
        label: 'Selected Request',
        type: 'text',
        value: 'selected_offer.quote_service_offer_id'
      },
      {
        label: 'NPA',
        type: 'text',
        value: 'npa'
      },
      {
        label: 'NXX',
        type: 'text',
        value: 'nxx'
      },
      {
        label: 'Quote Service Status',
        type: 'text',
        value: 'quote_service_status.value'
      },
      {
        label: 'Diversity',
        type: 'text',
        value: 'diversity'
      },
      {
        label: 'Install Date',
        type: 'date',
        value: 'desired_install_date'
      },
      {
        label: 'Vendor',
        type: 'text',
        value: 'current_vendor.name'
      },
      {
        label: 'Bandwidth',
        type: 'text',
        value: 'bandwidth'
      },
      {
        label: 'Country',
        type: 'text',
        value: 'country'
      },
      {
        label: 'Subdivision',
        type: 'text',
        value: 'subdivision'
      },
      {
        label: 'Address',
        type: 'text',
        value: 'address'
      }
    ];
  }

}
